import PricingToggle from './PricingToggle';
import { Check } from 'lucide-react';

const plans = [
  { nameKey: 'pricing.plan1_name', descKey: 'pricing.plan1_desc', monthlyKey: 'pricing.plan1_price_monthly', annualKey: 'pricing.plan1_price_annual', ctaKey: 'pricing.get_started', ctaTo: '/register', popular: false, features: ['5 GB depolama', '1 email ünvanı', 'IMAP/SMTP dəstəyi', 'Spam filtri', 'AZ/EN/RU interfeysi'] },
  { nameKey: 'pricing.plan2_name', descKey: 'pricing.plan2_desc', monthlyKey: 'pricing.plan2_price_monthly', annualKey: 'pricing.plan2_price_annual', ctaKey: 'pricing.get_started', ctaTo: '/register', popular: true, features: ['50 GB depolama', '5 email ünvanı', 'Xüsusi domen', 'Prioritet dəstək', 'Qabaqcıl spam filtri', 'AES-256 şifrələmə'] },
  { nameKey: 'pricing.plan3_name', descKey: 'pricing.plan3_desc', monthlyKey: 'pricing.plan3_price_monthly', annualKey: 'pricing.plan3_price_annual', ctaKey: 'pricing.contact_sales', ctaTo: '/support', popular: false, features: ['Limitsiz depolama', 'Limitsiz email ünvanı', 'Xüsusi domen', '7/24 dəstək', 'AI spam filtri', 'SSO inteqrasiyası', 'SLA zəmanəti'] },
];

export default function PricingCards() {
  const { t } = useTranslation();
  const [annual, setAnnual] = useState(false);
  return (
    <div>
      <PricingToggle annual={annual} onToggle={() => setAnnual(!annual)} />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {plans.map((plan, i) => (
          <div key={i} className={`relative rounded-2xl p-8 flex flex-col bg-white ${plan.popular ? 'border-2 border-primary-600 shadow-xl' : 'border border-slate-200 shadow-sm'}`}>
            {plan.popular && (
              <div className="absolute -top-3.5 left-1/2 -translate-x-1/2">
                <span className="bg-primary-600 text-white text-xs font-bold px-4 py-1.5 rounded-full whitespace-nowrap">{t('pricing.popular')}</span>
              </div>
            )}
            <div className="mb-6">
              <h3 className="font-display text-xl font-bold text-slate-900 mb-1">{t(plan.nameKey)}</h3>
              <p className="text-slate-500 text-sm">{t(plan.descKey)}</p>
            </div>
            <div className="mb-8">
              <span className="font-display text-4xl font-black text-slate-900">{annual ? t(plan.annualKey) : t(plan.monthlyKey)}</span>
              {t(plan.monthlyKey) !== '₼0' && <span className="text-slate-400 text-sm ml-1">{t('pricing.per_month')}</span>}
            </div>
            <ul className="space-y-3 mb-8 flex-1">
              {plan.features.map((f, j) => (
                <li key={j} className="flex items-center gap-2.5 text-sm text-slate-600">
                  <Check size={15} className="text-emerald-500 flex-shrink-0" />{f}
                </li>
              ))}
            </ul>
            <Link to={plan.ctaTo} className={`block text-center py-3 rounded-xl font-semibold text-sm transition-all ${plan.popular ? 'bg-primary-600 text-white hover:bg-primary-700' : 'border border-primary-200 text-primary-600 hover:bg-primary-50'}`}>
              {t(plan.ctaKey)}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
